import { Box, Stack } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

type TSelectableCardGroup = { children: React.ReactNode; title: string };

export const SelectableCardGroup = ({
  children,
  title,
  ...otherProps
}: TSelectableCardGroup) => {
  return (
    <Box {...otherProps}>
      <CustomTypography
        variant="subtitle1"
        sx={{ color: (theme) => theme.palette.custom.black[60] }}
        mb="10px"
      >
        {title}
      </CustomTypography>
      <Stack direction="row" spacing="11px">
        {children}
      </Stack>
    </Box>
  );
};
